<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <h4 class="ts-text-sm">
          {{
            $t(
              'school.academic.operation.profile_mgt.parentProfile.generatePickupCard'
            )
          }}
        </h4>
        <ts-modal-close-button />
      </div>
      <ts-card-wrapper>
        <div class="row mb-3">
          <div class="col-md-12 from-group">
            <label class="col-form-label required">
              {{
                $t(
                  'school.academic.operation.profile_mgt.parentProfile.branchName'
                )
              }}
              <i class="fa fa-spinner spin" v-if="fetch"></i>
            </label>
            <select
              class="form-control"
              v-model="model.branch_id"
              :disabled="fetch"
            >
              <option value="">{{ $t('select') }}</option>
              <option
                v-for="(branch, index) in branches"
                :value="branch.branch_id"
                :key="index"
              >
                {{ branch.branch_name_en }}
              </option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 from-group">
            <ts-checkbox v-model="model.is_auto_create_registration_card"
              >Is auto registration card activator</ts-checkbox
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-12 text-right">
            <ts-button class="mr-2" @click="$emit('close')">{{
              $t('cancel')
            }}</ts-button>
            <ts-button
              @click.prevent="generate"
              color="primary"
              :waiting="waiting"
              >{{ $t('generate') }}</ts-button
            >
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>
<script>
export default {
  name: 'generateCardParent',
  data () {
    return {
      model: {
        branch_id: '',
        is_auto_create_registration_card: false
      },
      branches: [],
      fetch: false,
      waiting: false
    }
  },
  created () {
    this.fetchBranch()
  },
  methods: {
    fetchBranch () {
      this.fetch = true
      this.$store
        .dispatch('parentProfile/getBranch')
        .then(response => {
          this.branches = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetch = false
        })
    },
    generate () {
      this.waiting = true
      this.$store
        .dispatch('parentProfile/generateCard', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('close')
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  }
}
</script>
